/**
 * @fileoverview Compose the Redux-backed calendar editor from focused CalendarInput sections. The form owns mount/reset lifetime; Redux owns the editable draft and the parent owns save/dismiss actions. Primary identity, timing, attachments, task options, assignees, and soft deadlines retain separate sections. A draft is distinct from a saved event and its remote synchronization state.
 */

import React from 'react';
import { connect } from 'react-redux';
import PrimaryInfo from '../CalendarInput/1_PrimaryInfo';
import DateTimeInfo from '../CalendarInput/2_DateTimeInfo';
import ExtraInfo from '../CalendarInput/3_ExtraInfo';
import TrelloTaskInfo from '../CalendarInput/4_TrelloTaskInfo';
import Actions from '../CalendarInput/5_Actions';
import EventsTableDialog from '../CalendarInput/6_EventsTableDialog';
import { 
    setCurrentlyEditingEvent, 
    resetForm 
} from '../../store/CalendarInput/action';
import AssigneeManagement from '../CalendarInput/AssigneeManagement';
import SoftDeadlinesSection from '../CalendarInput/SoftDeadlinesSection';



class EventForm extends React.Component {


    constructor(props) {
        super(props);
        this.clientNameRef = React.createRef();
        this.matterNumberRef = React.createRef();
    }



    componentDidMount() {
        if (this.props.event) {
            this.props.setCurrentlyEditingEvent(this.props.event);
        }
    }



    componentWillUnmount() {
        this.props.resetForm();
    }



    handleOverlayClick = (e) => {
        // Only close if clicking directly on the overlay, not on child elements
        if (e.target === e.currentTarget) {
            this.props.onClose();
        }
    }



    getCategoryColor() {
        const { selectedCategory } = this.props;
        if (!selectedCategory || !selectedCategory.color) {
            return 'gray';
        }
        return selectedCategory.color;
    }



    getModalTitle() {
        const { event, title, title2 } = this.props;
        const baseAction = event ? 'Edit Event' : 'Add New Event';
        
        // Construct the full title by combining title and title2 with a dash
        let computedTitle = '';
        if (title && title.trim()) {
            computedTitle = title.trim();
            if (title2 && title2.trim()) {
                computedTitle += ` - ${title2.trim()}`;
            }
        }
        
        // If we have a computed title, show it after the action
        if (computedTitle) {
            return `${baseAction}: ${computedTitle}`;
        }
        
        // Otherwise just show the action
        return baseAction;
    }



    render() {
        const { onSave, onClose, isSaving } = this.props;
        const categoryColor = this.getCategoryColor();

        return (
            <div className="event-form-overlay" onClick={this.handleOverlayClick}>
                <div className={`event-form-container glass-modal glass-${categoryColor}`}>
                    <h2>{this.getModalTitle()}</h2>
                    
                    {/* Two-column responsive layout: On lg+ screens, form sections
                        are arranged side-by-side to utilize horizontal space and
                        minimize scrolling. Uses primeflex grid system. */}
                    <div className="grid">
                        {/* Left column: Primary info and date/time settings */}
                        <div className="col-12 lg:col-6">
                            <div className="grid formgrid p-fluid">
                                <PrimaryInfo 
                                    clientNameRef={this.clientNameRef}
                                    matterNumberRef={this.matterNumberRef}
                                />
                                <DateTimeInfo />
                            </div>
                        </div>
                        
                        {/* Right column: Notes, files, assignees, and Trello task options */}
                        <div className="col-12 lg:col-6">
                            <div className="grid formgrid p-fluid">
                                <ExtraInfo />
                                <AssigneeManagement />
                                <TrelloTaskInfo />
                            </div>
                        </div>
                    </div>

                    {/* Soft Deadlines section - full width below the two-column layout */}
                    <SoftDeadlinesSection />

                    {/* Actions row: Stays at full width at the bottom */}
                    <div className="grid formgrid p-fluid mt-3">
                        <Actions onSave={onSave} onClose={onClose} isLoading={isSaving} />
                    </div>
                </div>
                <EventsTableDialog />
            </div>
        );
    }
}



const mapStateToProps = (state) => ({
    selectedCategory: state.calendarInput.selectedCategory,
    title: state.calendarInput.title,
    title2: state.calendarInput.title2
});

const mapDispatchToProps = {
    setCurrentlyEditingEvent,
    resetForm,
};

export default connect(mapStateToProps, mapDispatchToProps)(EventForm); 